import { awsApiInstance } from '../api/aws-api';
import { apiRetry } from '../api/api-helper';
import useAuth from '../hooks/auth-hooks';

import { ICustomerSearchResponse } from '../models/customer.interface';
import { handleRouteError } from './route-helpers/route-error';

/**
 * Gets a list customer based upon a search term
 * 
 * @param {string} searchTerm the search term for the customer list
 * 
 * @returns {object} the api response
 */
const SearchCustomers = async ( searchTerm: string ): Promise<ICustomerSearchResponse> => {
  try {
    apiRetry(awsApiInstance);

    const { userId } = useAuth()!;

    const { data } = await awsApiInstance.get('/customer/search', {
      params: {
        wpID: userId,
        searchTerm
      }
    });

    return data;
  } catch ( error ) {
    handleRouteError(error, 'Error getting customer search data');
    throw(error);
  }
}

export default SearchCustomers;